import { render, staticRenderFns } from "./PhenologicalTrackingTable.vue?vue&type=template&id=53b07c9c&scoped=true&lang=html&"
import script from "./PhenologicalTrackingTable.vue?vue&type=script&lang=js&"
export * from "./PhenologicalTrackingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b07c9c",
  null
  
)

export default component.exports